import { Box } from '@mui/material';

const Login = () => {
    return (
        <div className='page-back' style={{ minHeight: '600px'}}>
            <Box className='white-page p-4' sx={{ maxWidth: 450, margin: '40px auto', borderRadius: '15px'}}>
                <h1 style={{ textAlign: 'center', color: '#1b8fc9' }}>Log In</h1>
                <iframe src="https://www.caregivertraininguniversity.com/LoginFrame.aspx?css=https://247assurecare.com/login-form.css" width="100%" height="150" frameborder="0"></iframe>
            </Box>
        </div>
    );
};
export default Login;
